import React from 'react';
import { PropTypes } from 'prop-types';
import { capitalizeFirstLetter } from '../../../utils/api';
import Icon from '../../Icons/Icon';

const Number = ({
  label,
  name,
  value,
  setValue = () => { },
  placeholder,
  isValid = true,
  isRequired = false,
  asteriskWidth = 'w-2',
  className,
  borderColor = 'border-vamos-blue-gray',
  isLabelBeside = false,
  labelBesideInputClasses = undefined,
  labelBesideLabelClasses = undefined,
  fontSize = undefined,
  spaceY = undefined,
  inputHeight = undefined,
  labelFontSize = undefined,
  customWidth = '',
  shouldNotCapitalize = false,
  errorMessage = undefined,
  errorMessageClass = undefined,
  customErrorComponent = null,
  validationError = undefined,
  errorMessageFontClasses = undefined,
  isAlertIcon = false,
  min = undefined,
  max = undefined,
  step = undefined,
  isNegativeAllowed = true,
  dataTestId = undefined,
}) => {
  // render error message if any
  const isErrored = !!errorMessage || !!validationError;

  const renderError = () => {
    if (customErrorComponent) return customErrorComponent;

    const message = validationError || errorMessage;
    if (!message) return null;

    return (
      <h4
        type="invalid"
        className={`${errorMessageClass || ''} ${errorMessageFontClasses || 'text-vamos-red font-normal text-sm'}`}
      >
        <div className="flex items-start gap-x-1.5">
          {isAlertIcon && <Icon name="alert" />}
          {message}
        </div>
      </h4>
    );
  };
  return (
    <div className={`${spaceY || 'space-y-2'} ${isLabelBeside ? 'flex items-center' : ''} ${customWidth || 'w-full'}`}>
      {label && (
      <label
        className={`flex ${
          isLabelBeside
            ? `mb-0 ${labelBesideLabelClasses || 'w-2/5'} ${labelFontSize || 'font-bold text-base'}`
            : `mb-0 ${labelFontSize || 'text-sm font-medium'} flex`
        } text-vamos-black font-sans`}
      >
        {shouldNotCapitalize ? label : capitalizeFirstLetter(label)}
        {isRequired && <Icon name="required_field" className={`ml-1 mr-[2.5px] ${asteriskWidth}`} />}
      </label>
      )}
      <div className={isLabelBeside ? `${labelBesideInputClasses || 'w-3/5'}` : 'w-full'}>
        <input
          type="number"
          className={`
          arrow-hide border-solid border ${(isRequired && value === '') || (isRequired && !isValid) || (!isRequired && value !== '' && !isValid) ? 'border-vamos-red' : borderColor}
           rounded-md bg-vamos-white focus:border-vamos-black placeholder-vamos-gray py-1.5 px-3 focus:ring-0 w-full ${fontSize || 'text-base'} ${className || ''}
          ${isLabelBeside ? ` focus:border-vamos-black outline-none ${inputHeight || 'h-9'}` : `${inputHeight || 'h-8'}`}
          `}
          name={name}
          value={value ?? ''} // nullish coalescing preserves 0 as a valid displayed value
          onChange={(e) => {
            if (!isNegativeAllowed && e.target.value !== '' && parseFloat(e.target.value) < 0) return;
            setValue(e.target.value);
          }}
          placeholder={placeholder}
          min={!isNegativeAllowed ? 0 : min}
          max={max}
          step={step}
          data-testid={dataTestId}
        />
        {isErrored && renderError()}
      </div>
    </div>
  );
};

Number.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setValue: PropTypes.func,
  placeholder: PropTypes.string,
  isValid: PropTypes.bool,
  className: PropTypes.string,
  borderColor: PropTypes.string,
  isLabelBeside: PropTypes.bool,
  labelBesideInputClasses: PropTypes.string,
  labelBesideLabelClasses: PropTypes.string,
  spaceY: PropTypes.string,
  fontSize: PropTypes.string,
  labelFontSize: PropTypes.string,
  inputHeight: PropTypes.string,
  customWidth: PropTypes.string,
  isRequired: PropTypes.bool,
  asteriskWidth: PropTypes.string,
  shouldNotCapitalize: PropTypes.bool,
  errorMessage: PropTypes.string,
  customErrorComponent: PropTypes.node,
  validationError: PropTypes.string,
  errorMessageClass: PropTypes.string,
  isAlertIcon: PropTypes.bool,
  errorMessageFontClasses: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  isNegativeAllowed: PropTypes.bool,
  dataTestId: PropTypes.string,
};

export default Number;
